import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { MdEmail, MdLink, MdTextFields, MdNumbers, MdAttachMoney, MdCalendarToday, MdPhone, MdBusiness, MdPerson } from 'react-icons/md';

type VariableChipProps = {
    value: string;
    isVariable: boolean;
    onRemove: () => void;
    format?: string;
    prefix?: string;
    customIcon?: React.ReactNode;
    title?: string;
};

const VariableChip: React.FC<VariableChipProps> = ({
    value,
    isVariable,
    onRemove,
    format,
    prefix,
    customIcon,
    title
}) => {
    const getIcon = () => {
        if (customIcon) return customIcon;
        if (!isVariable) return null;
        
        if (format) {
            switch (format.toLowerCase()) {
                case 'email': return <MdEmail className="inline" />;
                case 'fileurl': return <MdLink className="inline" />;
                case 'number': return <MdNumbers className="inline" />;
                case 'currency': return <MdAttachMoney className="inline" />;
                case 'date': return <MdCalendarToday className="inline" />;
                case 'phone': return <MdPhone className="inline" />;
                case 'cnpj':
                case 'govtaxid': return <MdBusiness className="inline" />;
                case 'cpf':
                case 'socialid': return <MdPerson className="inline" />;
                default: return <MdTextFields className="inline" />;
            }
        }
        
        return <MdTextFields className="inline" />;
    };

    return (
        <span
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ${
                isVariable
                    ? 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300'
                    : 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300'
            }`}
            title={title}
        >
            {getIcon()}
            {prefix && <span className="font-medium">{prefix}</span>}
            <span>{value}</span>
            <button
                type="button"
                onClick={onRemove}
                className="hover:bg-black/10 rounded-full p-0.5"
            >
                <FaTimes className="w-2.5 h-2.5" />
            </button>
        </span>
    );
};

export default VariableChip;
